import { render } from "./NcrmActivityListCard.vue?vue&type=template&id=1486f4dc&scoped=true"
import script from "./NcrmActivityListCard.vue?vue&type=script&lang=js"
export * from "./NcrmActivityListCard.vue?vue&type=script&lang=js"

import "./NcrmActivityListCard.vue?vue&type=style&index=0&id=1486f4dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1486f4dc"]])

export default __exports__